import script from "./Logs.vue?vue&type=script&setup=true&lang=js"
export * from "./Logs.vue?vue&type=script&setup=true&lang=js"

import "./Logs.vue?vue&type=style&index=0&id=71099856&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71099856"]])

export default __exports__